export default __webpack_public_path__ + "static/netlify-1aa9d38d068f8778556820c1e958c419.png";